import { render } from "./Badge.vue?vue&type=template&id=6eaab310&scoped=true&ts=true"
import script from "./Badge.vue?vue&type=script&lang=ts"
export * from "./Badge.vue?vue&type=script&lang=ts"

import "./Badge.vue?vue&type=style&index=0&id=6eaab310&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eaab310"]])

export default __exports__